module.exports = __webpack_public_path__ + "static/media/020.44a4863d.jpg";